export enum PageView {
    BeforeLoaded,
    Welcome,
    FormPages,
    Review,
    ThankYou,
    Error
}
